/**
 * OrgHome — landing for /o/:orgId (a customer, no site selected).
 *
 * Since the Customer menu redesign (2026-10-07) the customer landing is the OVERVIEW: one row
 * per site with its devices / offline / clients / firmware / alerts roll-up (the Meraki
 * "Networks" table). Before that, the customer landing was the Health dashboard; Health is
 * still one click away at /o/:orgId/dashboard (Customer > Monitor > Health), and every nav
 * link now targets that explicit path.
 *
 * A REDIRECT to ./overview rather than rendering the page here, so the URL names the screen:
 * the nav highlights the right item, a bookmark of the landing is a bookmark of the Overview,
 * and the scope bar's "keep my section when I switch site" logic sees a real section.
 * RootRedirect, Customers, the command palette and the scope bar all navigate to /o/:orgId,
 * so they land on the Overview unchanged. A site landing (/o/:orgId/s/:siteId) still opens on
 * Health.
 */
import { Navigate } from "react-router-dom";

export default function OrgHome() {
  return <Navigate to="overview" replace />;
}
